var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"text-reader"},[_vm._v(" Load GPX file "),_c('input',{attrs:{"type":"file"},on:{"change":_vm.loadTextFromFile}})])}
var staticRenderFns = []

export { render, staticRenderFns }